// window._ = require('lodash');

// try {
//     require('bootstrap');
// } catch (e) {}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

window.Pusher = Pusher;

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: import.meta.env.MIX_PUSHER_APP_KEY,
//     wsHost: import.meta.env.MIX_PUSHER_HOST,
//     wsPort: import.meta.env.MIX_PUSHER_PORT,
//     cluster: import.meta.env.MIX_PUSHER_APP_CLUSTER,
//     forceTLS: false,
//     disableStats: true,
// });

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: 'd9cadc88a49a794f5611',
//     wsHost: '127.0.0.1',
//     wsPort: 6001,
//     forceTLS: false,
//     disableStats: true,
//     cluster: 'ap1',
// });

window.Echo = new Echo({
    broadcaster: 'pusher',
    key: 'd9cadc88a49a794f5611',
    wsHost: 'websocket.pzmrydrs.com',
    wsPort: 443,
    forceTLS: false,
    disableStats: true,
    cluster: 'ap2',
});
